let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a11r2")).then(() => parcelRequire('bDEAQ'));